import { Injectable } from '@angular/core';
import { HttpCustomService } from "./http-custom.service";

@Injectable()
export class WorkSpaceService {

    baseUrl = 'ws_app/';

    constructor(
        private customHttpService: HttpCustomService,
    ) { }

    getFields (users, transform, callBack, settings = {}) {
        const path = this.baseUrl + 'fields/';
        this.customHttpService.fetchData(path, (response) => {
            if (transform) {
                if (response.status) {
                    const fields = [];
                    let fieldView = {};
                    if (settings.hasOwnProperty('fieldView')) {
                        fieldView = settings['fieldView'];
                    }

                    response.data.forEach((field) => {

                        let type = "text";
                        switch (field.attr_field) {
                            case "IntegerField": {
                                type = "number";
                                break;
                            }
                            case "CharField": {
                                type = "text";
                                break;
                            }
                            case "TextField": {
                                type = "text";
                                break;
                            }
                            case "ForeignKey": {
                                type = "text";
                                break;
                            }
                            case "DateField": {
                                type = "date";
                                break;
                            }
                        }

                        let choices = [];
                        if ((field['attr_kwargs'].hasOwnProperty("choices") && Object.keys(field['attr_kwargs'].choices).length > 0) || field.key_name === 'resource_analyst' || field.key_name === 'reviewer') {
                            type = "choice";
                            choices.push({
                                id: 'null',
                                text: "All"
                            });

                            if (field.key_name === 'resource_analyst' || field.key_name === 'reviewer') {
                                choices = choices.concat(users);
                            } else {
                                Object.keys(field['attr_kwargs'].choices).forEach(key => {
                                    choices.push(
                                        {
                                            id: key,
                                            text: field['attr_kwargs'].choices[key]
                                        }
                                    )
                                });
                            }
                        }
                        field.choices = choices;
                        const editable = (field['key_name'] !== 'id' && field['key_name'] !== 'qced_date' && field['key_name'] !== 'submission_date' && field['key_name'] !== 'patent_number');

                        let hidden = false;
                        if (field['key_name'] === 'hyperlink' || field['col_is_hidden']) {
                            hidden = true;
                        }

                        if (!hidden && fieldView.hasOwnProperty(field['key_name'])) {
                            hidden = fieldView[field['key_name']];
                        }

                        fieldView[field['key_name']] = hidden;

                        let width = "200";
                        if (settings.hasOwnProperty('fieldWidths')) {
                            const fieldWidths = settings['fieldWidths'];
                            if (fieldWidths.hasOwnProperty(field['key_name'])) {
                                width = fieldWidths[field.key_name].toString();
                            } else if (field['key_name'] === 'id') {
                                width = "90";
                            }
                        } else if (field['key_name'] === 'id') {
                            width = "90";
                        }

                        fields.push({
                            name: field.display_name,
                            prop: field.key_name,
                            type: type,
                            choices: choices,
                            editable: editable,
                            hidden: hidden,
                            col_is_hidden: field['col_is_hidden'],
                            width: width,
                            required: field.required,
                            filled_by: field['filled_by'],
                            attr_field: field.attr_field,
                            col_width: field.col_width
                        });
                    });

                    // Add action column
                    fields.push(
                        {
                            name: "Actions",
                            prop: "actions",
                            type: "action",
                            choices: [],
                            editable: true,
                            hidden: false,
                            width: "90",
                            filled_by: "admin"
                        }
                    );

                    if (settings.hasOwnProperty('fieldOrder')) {
                        const fieldOrder = settings['fieldOrder'];
                        fields.sort((a, b) => {
                            const A = a['prop'], B = b['prop'];

                            if (fieldOrder.indexOf(A) > fieldOrder.indexOf(B)) {
                                return 1;
                            } else {
                                return -1;
                            }
                        });
                    }
                    response.data = fields;
                }
                callBack(response);
            } else {
                callBack(response);
            }
        });
    }

    importExcel (data, callBack) {
        const path = this.baseUrl + 'upload/';
        this.customHttpService.postData(data, path, callBack, true);
    }

    getTasks (limit, offset, sort, filter, isExport, isAdmin, userId, callBack) {
        if (filter !== "") {
            filter = "&" + filter;
        }
        let path = this.baseUrl + `tasks/?`;

        if (isExport) {
            path = this.baseUrl + `export/?`;
        }

        if (!isAdmin) {
            path += `analyst=${userId}&`;
        }

        path += `limit=${limit}&offset=${offset}&ordering=${sort}${filter}`;
        this.customHttpService.fetchData(path, callBack, isExport);
    }

    editTask (taskId, data, callBack) {
        const path = this.baseUrl + `tasks/${taskId}/edit/`;
        this.customHttpService.postData(data, path, callBack, false);
    }

    downloadTemplate (callBack) {
        const path = this.baseUrl + `template/`;
        this.customHttpService.fetchData(path, callBack, true);
    }

    getLock(callBack) {
        const path = this.baseUrl + `locks/`;
        this.customHttpService.fetchData(path, callBack, false);
    }

    deleteLock(callBack) {
        const path = this.baseUrl + `locks/`;
        this.customHttpService.deleteData(path, callBack);
    }

    modifyFields(data, callBack) {
        const path = `${this.baseUrl}fields/`;
        this.customHttpService.postData(data, path, callBack, false);
    }
}
